import { render, staticRenderFns } from "./Desincorporacion.vue?vue&type=template&id=bf6c2040&"
import script from "./Desincorporacion.vue?vue&type=script&lang=js&"
export * from "./Desincorporacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports